// src/components/asset/AssetMediaDisplay.tsx

import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import Carousel from "../carousel/Carousel";
import { useAsset } from "../../context/AssetContext";
import { useSession } from "../../context/SessionContext";
import { resolveCameraDirection } from "../../utils/assetCameraDirection";

const AssetMediaDisplay: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const {
    systemCode, assetId, asset,
    visibleTypes, imageCategories
  } = useAsset();
  const { systems } = useSession();
  const cameraDirection = resolveCameraDirection(asset, systems);

  return (
    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
      {/* --- Native Carousels (No changes needed here) --- */}
      {imageCategories.map(({ key, label, images }) => {
        if (!visibleTypes[key] || images.length === 0) return null;
        
        const isUndercarriage =
          label.toLowerCase().includes("undercarriage") ||
          key.toLowerCase().includes("uc");
        const gridSize = isMobile ? 12 : (isUndercarriage && images.length > 1 ? 12 : 6);

        return (
          <Grid item xs={12} md={gridSize} key={key} data-cy={`carousel-section-${key}`}>
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Typography variant="h6" gutterBottom>
                {label} Images
              </Typography>
              <Carousel assetId={assetId || ''} images={images} cameraDirection={cameraDirection} />
            </Box>
          </Grid>
        );
      })}

      {/* --- iFrame Previews --- */}

      {/* iFrame (All) */}
      <Grid item xs={12} md={6}> {/* On desktop, this will take up 6 columns */}
        <Typography variant="h6" gutterBottom>
          iFrame Preview (All)
        </Typography>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: isMobile ? '100%' : '75%',
          }}
        >
          <iframe
            src={`/iframe/${systemCode}/${assetId}`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: "10px",
              border: "none",
              // The problematic minHeight has been removed.
            }}
            allow="fullscreen"
            allowFullScreen
          />
        </Box>
      </Grid>

      {/* iFrame (Exterior) */}
      <Grid item xs={12} md={6}> {/* On desktop, this will also take up 6 columns */}
        <Typography variant="h6" gutterBottom>
          iFrame Preview (Exterior)
        </Typography>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: isMobile ? '100%' : '75%',
          }}
        >
          <iframe
            src={`/iframe/${systemCode}/${assetId}/ext-crop-feat`}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: "10px",
              border: "none",
              // The problematic minHeight has been removed.
            }}
            allow="fullscreen"
            allowFullScreen
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default AssetMediaDisplay;
